module.exports = __webpack_public_path__ + "static/22-41985064643e72ef9c6302df980b202c.png";